'use strict';

intellidealerAppShoppingCartModule.controller('addressPopupCtrl', function($scope, $uibModalInstance, properties) {
  $scope.avalaraSuggestedAddress = properties.avalaraSuggestedAddress;

  $scope.dismiss = function (value) {
    $uibModalInstance.close(value);
  }
});
